import { render, staticRenderFns } from "./InsectHistory.vue?vue&type=template&id=07e3dd99&scoped=true"
import script from "./InsectHistory.vue?vue&type=script&lang=js"
export * from "./InsectHistory.vue?vue&type=script&lang=js"
import style0 from "./InsectHistory.vue?vue&type=style&index=0&id=07e3dd99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e3dd99",
  null
  
)

export default component.exports